import React from 'react';
import './Machinedetails.css';

import platenImg from '../../../imgs/threeplaten.webp';
import pullrodImg from '../../../imgs/duplexpull.webp';
import oilImg from '../../../imgs/oilcircuit.webp';
import frameImg from '../../../imgs/rigidframe.webp';
import railImg from '../../../imgs/guiderail.webp';
import airImg from '../../../imgs/airblowing.webp';

const cardData = [
  {
    img: platenImg,
    title: "3-Platen Clamping System",
    desc: "Optimizes stress distribution, higher rigidity & stable performance for rapid mechanical movement."
  },
  {
    img: pullrodImg,
    title: "Duplex Pull Rods",
    desc: "Ensures precise centering and stronger injection movement structure."
  },
  {
    img: oilImg,
    title: "Oil Circuit Design",
    desc: "Special oil circuit improves injection acceleration and smooth movement."
  },
  {
    img: frameImg,
    title: "Rigid Frame",
    desc: "Shock-absorbing design for more stable and reliable production."
  },
  {
    img: railImg,
    title: "Guide Rail",
    desc: "Low resistance linear rail for precise positioning and high repeatability."
  },
  {
    img: airImg,
    title: "Air Blowing",
    desc: "Multiple air blowing sets for fast cycle and high-efficiency production."
  }
];

const Machinedetails = () => {
  return (
    <div className="machine-wrapper">
      <h1 className="section-machine-title">Machine Details</h1>
      <div className="machine-grid">
        {cardData.map((card, index) => (
          <div className="machine-card" data-aos="fade-down" key={index}>
            <img src={card.img} alt={card.title} />
            <h3>{card.title}</h3>
            <p>{card.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Machinedetails;
